import React, { useEffect, useState, useMemo } from "react";
import "./styles.css";
import { ASSETS } from "../../utils/config";
import MailRoundedIcon from "@mui/icons-material/MailRounded";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { useSelector } from "react-redux";
import {
  WhatsappShareButton,
  WhatsappIcon,
  FacebookMessengerShareButton,
  FacebookMessengerIcon,
} from "react-share";
import { toast } from "react-toastify";
import WheelComponent from "../WheelComponent";
import { useNavigate } from "react-router-dom";
import { getLatestWheelToShowInReferModal } from "../../services/api";
import UserImage from "../UserImage";
import styled from "styled-components";
import MobileVersion from "./MobileVersion";
import useScreenSize from "../../hooks/useScreenSize";
import { useDispatch } from "react-redux";

function ShareInviteModal({ isVisible, onClose, isReferral = false }) {
  const { userProfile } = useSelector((state) => state.userProfile);
  const [wheelToRender, setWheelToRender] = useState(null);
  const { isMobilePortrait } = useScreenSize();
  const dispatch = useDispatch();
  const nav = useNavigate();
  const [showShareOptions, setShowShareOptions] = useState(false);

  // Create a copy of each segment object (to avoid mutation issues)
  const wheelUpdatedData = useMemo(
    () =>
      wheelToRender?.wheel_segments?.length > 0
        ? wheelToRender.wheel_segments.map((obj) => ({ ...obj }))
        : [],
    [wheelToRender?.wheel_segments]
  );

  // Sort the segments by position
  const wheelUpdatedDataSorted = useMemo(
    () =>
      wheelUpdatedData?.length > 0
        ? [...wheelUpdatedData].sort((a, b) => a.position - b.position)
        : [],
    [wheelUpdatedData]
  );

  // Extract just the domain from the URL
  const getDomain = () => {
    const url = window.location.href;
    const urlObj = new URL(url);
    return `${urlObj.protocol}//${urlObj.host}`;
  };

  const currentUrl = getDomain();
  const referralUrl = userProfile?.is_in_referral_program
    ? `${currentUrl}/signup/${userProfile?.code}`
    : `${currentUrl}/signup`;

  const quote = "Check out this amazing content!";

  const copyToClipboard = (toCopyText = referralUrl) => {
    navigator.clipboard
      .writeText(toCopyText)
      .then(() => {
        toast.success("Copied to clipboard!");
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);
      });
  };

  const handleEmailShare = () => {
    const subject = "Check out this amazing content!";
    const body = `${capitalize(
      userProfile?.username
    )} has invited you to get your own free iYuga account!... ${referralUrl}`;
    window.location.href = `mailto:?subject=${encodeURIComponent(
      subject
    )}&body=${encodeURIComponent(body)}`;
  };

  // Create the invite message text with HTML for the hyperlink
  const inviteMessage = `${capitalize(
    userProfile?.username
  )} has invited you to get your own free iYuga account!... ${referralUrl}`;

  useEffect(() => {
    const getWheelToRender = async () => {
      const response = await getLatestWheelToShowInReferModal(
        userProfile?.user_id
      );
      setWheelToRender(response.data.data);
      console.log(response, "response");
    };

    if (isVisible && userProfile?.user_id) {
      getWheelToRender();
      // Set showShareOptions to true if user is in Earnings Program
      if (userProfile?.is_in_referral_program) {
        setShowShareOptions(true);
      }
    }
    if (!isVisible) {
      setShowShareOptions(false);
    }
  }, [isVisible, userProfile?.user_id, userProfile?.is_in_referral_program]);

  function capitalize(str) {
    return str?.charAt(0).toUpperCase() + str?.slice(1);
  }

  // Add ref for the modal container
  const modalRef = React.useRef(null);

  // Add handler for overlay clicks
  const handleOverlayClick = (event) => {
    // If clicking the overlay (not the modal itself), close the modal
    if (modalRef.current && !modalRef.current.contains(event.target)) {
      onClose();
    }
  };

  if (!isVisible) return null;

  if (isMobilePortrait) {
    return (
      <MobileVersion
        isVisible={isVisible}
        onClose={onClose}
        isReferral={!userProfile?.is_in_referral_program}
        wheelToRender={wheelUpdatedDataSorted}
      />
    );
  }

  return (
    // Add onClick to the overlay
    <div className="modal-overlay" onClick={handleOverlayClick}>
      {/* Add ref to the modal container */}
      <div className="modal-container" ref={modalRef}>
        {!showShareOptions ? (
          <>
            <div className="modal-header">
              <div
                style={{ display: "flex", alignItems: "center", gap: "10px" }}
              >
                <img src={ASSETS.InviteShare} alt="Add Group" />
                <div className="modal-title">
                  <h2>Invite Friends</h2>
                </div>
              </div>
              <button className="close-button" onClick={onClose}>
                <span>×</span>
              </button>
            </div>
            <div className="divider" />
            <div className="referral-content">
              <div className="referral-icon">
                <img src={ASSETS.Referrals} alt="Add Group" />
              </div>
              <p className="referral-text">
                You're about to invite somebody to enjoy the iYuga app! Want to
                get paid for sharing? Join our Earnings Program, available to
                all Premium or higher subscribers.
              </p>
              <div className="referral-buttons">
                <button
                  className="join-now-btn"
                  onClick={() => nav("/referrals")}
                >
                  Join Now
                </button>
                <button
                  className="share-anyway-btn"
                  onClick={() => setShowShareOptions(true)}
                >
                  Invite Anyway
                </button>
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="modal-header">
              <div className="modal-title">
                <h2>Share iYuga</h2>
              </div>
              <button className="close-button" onClick={onClose}>
                <span>×</span>
              </button>
            </div>
            <div className="divider" />
            <div className="modal-content">
              {/* New Invite Message Section */}
              <div className="invite-message-section">
                <div className="invite-message-header">
                  <h3>Invite Message with Link</h3>
                  <button
                    className="copy-link"
                    onClick={() => copyToClipboard(inviteMessage)}
                  >
                    <ContentCopyIcon
                      style={{ color: "#9B5AF8", fontSize: "15px" }}
                    />
                  </button>
                </div>
                <div className="invite-message-content">
                  <div className="user-avatar">
                    {wheelToRender ? (
                      <WheelComponent
                        userData={{
                          id: Math.random(),
                          url: userProfile?.profile_image || ASSETS.iyugaLogo,
                        }}
                        maxSelectedArcs={0}
                        arcThickness={-10}
                        chartData={wheelUpdatedDataSorted}
                        margin={1}
                        setChartData={() => {}}
                        containerDivStyle={{
                          width: "100%",
                          height: "100%",
                          maxWidth: "72px",
                          maxHeight: "72px",
                        }}
                        config={{
                          showTooltips: false,
                        }}
                      />
                    ) : (
                      <UserImage
                        image={userProfile?.profile_image}
                        size={72}
                        style={{ marginRight: 10 }}
                      />
                    )}
                  </div>
                  <p className="invite-text">
                    {capitalize(userProfile?.first_name) +
                      " " +
                      capitalize(userProfile?.last_name)}{" "}
                    has invited you to join iYuga! Click here to Bundle, Share,
                    and Engage:{" "}
                    <a
                      href={referralUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="invite-link"
                    >
                      {referralUrl}
                    </a>
                  </p>
                </div>
              </div>

              <div className="link-section">
                <div className="link-header">
                  <h3>Link Only</h3>
                  <button
                    className="copy-link"
                    onClick={() => copyToClipboard(referralUrl)}
                  >
                    <ContentCopyIcon
                      style={{ color: "#9B5AF8", fontSize: "15px" }}
                    />
                  </button>
                </div>
                <div className="link-container">
                  <input type="text" value={referralUrl} readOnly />
                </div>
              </div>

              {/* <div className="share-options">
                <div className="share-option" onClick={handleEmailShare}>
                  <div className="share-icon email">
                    <MailRoundedIcon
                      style={{ color: "white", fontSize: "20px" }}
                    />
                  </div>
                  <span>Mail</span>
                </div>

                <div className="share-option">
                  <WhatsappShareButton url={inviteMessage} title={""}>
                    <div className="share-icon whatsapp">
                      <WhatsappIcon size={32} round />
                    </div>
                  </WhatsappShareButton>
                  <span>Whatsapp</span>
                </div>
              </div> */}
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default ShareInviteModal;
